import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const IntegratedSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [locationKey, setLocationKey] = useState('');
  const [searchParams] = useSearchParams();
  const paramValue = searchParams.get('searchText');
  const inputRef = useRef(null);

  const [searchText, setSearchText] = useState(paramValue || '');
  const [noticeList, setNoticeList] = useState([]);
  const [businessList, setBusinessList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [employmentList, setEmploymentList] = useState([]);
  const [bidList, setBidList] = useState([]);
  const [newsList, setNewsList] = useState([]);
  const [referenceList, setReferenceList] = useState([]);
  const [archiveList, setArchiveList] = useState([]);
  const [inquiryList, setInquiryList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  // 어떤 보드를 필터링할지 (all / notice / business / ...)
  const [activeCate, setActiveCate] = useState('all');

  useEffect(() => {
    if (locationKey === '') {
      setLocationKey(location.key);
    }

    if (locationKey !== '' && locationKey !== location.key) {
      window.location.reload();
    }
  }, [location.key]);

  useEffect(() => {
    getSearchList();
  }, []);

  const getSearchList = () => {
    axios
      .get(`https://ciuc.or.kr:8443/api/get/intergratedSearch?searchText=${searchText}`)
      .then((res) => {
        const { notice, business, education, employment, bid, news, reference, archive, inquiry } = res.data.data;
        setNoticeList(notice);
        setBusinessList(business);
        setEducationList(education);
        setEmploymentList(employment);
        setBidList(bid);
        setNewsList(news);
        setReferenceList(reference);
        setArchiveList(archive);
        setInquiryList(inquiry);

        const total =
          notice.length +
          business.length +
          education.length +
          employment.length +
          bid.length +
          news.length +
          reference.length +
          archive.length +
          inquiry.length;
        setTotalCount(total);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const moveBoard = (cate, idx) => {
    navigate(`/board/${cate}/${idx}`, { state: { cate: cate } });
  };

  const search_btn = () => {
    if (!searchText.trim()) return;
    navigate(`/integratedSearch?searchText=${searchText}`);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      search_btn();
    }
  };

  // 카테고리 메타 정의
  const sections = [
    { key: 'notice', label: '공지사항', list: noticeList },
    { key: 'business', label: '사업공고', list: businessList },
    { key: 'education', label: '교육공고', list: educationList },
    { key: 'employment', label: '채용공고', list: employmentList },
    { key: 'bid', label: '입찰공고', list: bidList },
    { key: 'news', label: '보도자료', list: newsList },
    { key: 'reference', label: '자료실', list: referenceList },
    { key: 'archive', label: '융합원 아카이브', list: archiveList },
    { key: 'inquiry', label: '입주문의', list: inquiryList },
  ];

  // 모든 결과를 한 리스트로 평탄화
  const flatResults = sections.flatMap((sec) =>
    sec.list.map((item) => ({
      ...item,
      cate: sec.key,
      cateLabel: sec.label,
    }))
  );

  const filteredResults = activeCate === 'all' ? flatResults : flatResults.filter((item) => item.cate === activeCate);

  return (
    <div className="search_wrap">
      <div className="search_back">
        <div className="search_container">
          {/* 타이틀 영역 */}
          <div className="title_box">
            <div className="title_text">통합검색</div>
            <div className="total_count">
              총 <span>{totalCount}</span>건의 게시글이 검색되었습니다.
            </div>
          </div>

          {/* 상단 검색바 */}
          <div className="search_box">
            <input
              className="search_input"
              placeholder="검색어를 입력하세요."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              ref={inputRef}
              onKeyDown={handleKeyDown}
            />
            <div className="search_btn" onClick={search_btn} aria-label="검색 실행" />
          </div>

          {/* 카테고리 요약 & 필터 */}
          {!loading && (
            <div className="list_area">
              <div className="category_summary">
                <button
                  type="button"
                  className={`summary_chip ${activeCate === 'all' ? 'active' : ''}`}
                  onClick={() => setActiveCate('all')}
                >
                  전체
                  <span className="count">{totalCount}</span>
                </button>

                {sections.map((sec) => (
                  <button
                    key={sec.key}
                    type="button"
                    className={`summary_chip ${activeCate === sec.key ? 'active' : ''} ${
                      sec.list.length === 0 ? 'empty' : ''
                    }`}
                    onClick={() => setActiveCate(sec.key)}
                  >
                    {sec.label}
                    <span className="count">{sec.list.length}</span>
                  </button>
                ))}
              </div>

              {/* 결과 리스트 – 한 화면에 다 모아서 */}
              <div className="result_list">
                {totalCount === 0 ? (
                  <div className="empty_state">검색결과가 없습니다.</div>
                ) : filteredResults.length === 0 ? (
                  <div className="empty_state small">선택하신 카테고리에 검색결과가 없습니다.</div>
                ) : (
                  filteredResults.map((item) => (
                    <div
                      key={`${item.cate}-${item.idx}`}
                      className="result_row"
                      onClick={() => moveBoard(item.cate, item.idx)}
                    >
                      <div className={`result_badge cate_${item.cate}`}>{item.cateLabel}</div>
                      <div className="result_title">{item.title}</div>
                      <div className="result_date">{item.date_format}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntegratedSearch;
